import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';


@Injectable({
	providedIn: 'root',
})
export class ProductionBoardService {
	constructor(private http: HttpClient, private utils: UtilsService) {}

	getUsersData(): Promise<any> {
		return this.http
			.get(`${environment.api}production_board/get_users_data`)
			.toPromise();
	}

	getProductionBoard(): Promise<any> {
		return this.http
			.get(`${environment.api}production_board/get_production_board`)
			.toPromise();
	}

	getProductionBoardWeekly(): Promise<any> {
		return this.http
			.get(
				`${environment.api}production_board/get_production_board_weekly`,
			)
			.toPromise();
	}

	getWeekBoard(week_id: string): Observable<any> {
		const formData = new FormData();
		formData.append('week_id', week_id);
		return this.http.post(
			`${environment.api}production_board/get_week_board`,
			formData,
		);
	}

	updateWeekBoardEntry(payload: {
		campaign_id: number;
		week_id: string;
		day: string;
		value: number;
	}): Observable<any> {
		const formData: FormData = this.utils.jsonToFormData(payload);
		return this.http.post(
			`${environment.api}production_board/update_week_board_entry`,
			formData,
		);
	}

	updateLeadsOrdered(payload: {
		campaign_id: number;
		week_id: string;
		leads_ordered: number;
	}): Observable<any> {
		const formData: FormData = this.utils.jsonToFormData(payload);
		return this.http.post(
			`${environment.api}production_board/update_leads_ordered`,
			formData,
		);
	}

	updateLeadCost(payload: {
		campaign_id: number;
		week_id: string;
		lead_cost: number;
	}): Observable<any> {
		const formData: FormData = this.utils.jsonToFormData(payload);
		return this.http.post(
			`${environment.api}production_board/update_lead_cost`,
			formData,
		);
	}
}
